import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { UtilService } from '../util.service';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';
import { ModuleAssessmentBatchDate } from 'src/app/models/assessment/assessmentsubmission.model';

@Injectable({
  providedIn: 'root'
})
export class AssessmentmanagerService {

  readonly bufferRoute = {
    Details: 1,
    AddQuestion: 2,
    EditQuestion: 3,
    EditAssessment: 4,
    NewAssessment: 5,
    AssessmentConsole: 6
  }

  readonly ModalDefaultOptionCount = 3;

  readonly activityType = {
    Create: 1,
    Edit: 2,
    Delete: 3
  }

  readonly LocalStorage_FLAG = {
    deliveryType: "adm",
    questionType: "qtype",
    AssesmentTitle: "atitle",
    currentAssessmentCache: "a_chc"
  }

  readonly QuestionTypeFlags = {
    essayQuestionFlag: "LongText",
    fileQuestionFlag: "FileUpload",
    multichoiceQuestionFlag: "MultipleChoice"
  }


  readonly DeliveryModeFlags = {
    Timed: "TimedAssessment",
    UnTimed: "UntimedAssessment"
  }


  readonly rootURL = environment.ImpataAppAPIRoot;

  constructor(private http: HttpClient, private router: Router, private util: UtilService) { }

  async getClassAssessments(classID: number, batchid:number) {
    return this.http.get<any>(this.rootURL + `assessment/getclassassessments?id=${classID}&batchid=${batchid}`).toPromise();
  }

  async getCourseAssessments(id: number, batchid:number) {
    return this.http.get<any>(this.rootURL + `assessment/getcourseassessments?id=${id}&batchid=${batchid}`).toPromise();
  }

  async getAssessmentsForDashboard() {
    if(!await this.util.hasFeature(FeatureGroups.ASSESSMENTS)){
      return [];
    }
    return this.http.get<any>(this.rootURL + `assessment/getdeadlineassessments`).toPromise();
  }

  async getCalendarAssessmentsForAdmin() {
    if(!await this.util.hasFeature(FeatureGroups.ASSESSMENTS)){
      return [];
    }
    return this.http.get(this.rootURL + `assessment/getcalendarassessmentsforadmin`).toPromise();
  }

  async getAssessmentsForStudent() {
    if(!await this.util.hasFeature(FeatureGroups.ASSESSMENTS)){
      return [];
    }
    return this.http.get(this.rootURL + `assessment/getstudentassessments`).toPromise();
  }

  getAssessmentFile(questionID: number, studentID: number) {
    return this.http.get(this.rootURL + `assessment/getassessmentfiles?qid=${questionID}&stdid=${studentID}`);
  }

  getAssessmentDetails(aid: number,batchid:number) {
    return this.http.get(this.rootURL + `assessment/details?aid=${aid}&batchid=${batchid}`);
  }

  getAssessmentDetails_scoringview(aid: number, studentId: number,moduleid:number) {
    return this.http.get(this.rootURL + `assessment/scoringdetails?aid=${aid}&stdid=${studentId}&moduleid=${moduleid}`);
  }

  ///SUBMIT ASSESSMENTS ---------------------
  submitAssessment(model: any) {
    return this.http.post(this.rootURL + `assessment/submitassessment`, model);
  }

  submitAssessmentMarking(markings: any) {
    return this.http.post(this.rootURL + `assessment/submitassessmentmarking`, markings);
  }


  submitFileUploadAssessment(answerFile: FormData, questionID: number, isDraft: boolean, moduleId: number) {
    return this.http.post(this.rootURL + `assessment/submitfileuploadassessment?questionid=${questionID}&isdraft=${isDraft}&moduleid=${moduleId}`, answerFile);
  }

  async getAssessmentSubmissions(assessmentID: number, batchID: number) {
    if(!await this.util.hasFeature(FeatureGroups.ASSESSMENTS)){
      return [];
    }
    return this.http.get(this.rootURL + `assessment/getsubmissions?aid=${assessmentID}&batchid=${batchID}`).toPromise();
  }

  getAssessmentMarksheet(assessmentID: number,batchID:number) {
    return this.http.get(this.rootURL + `assessment/getmarksheet?aid=${assessmentID}&batchid=${batchID}`);
  }

  ///SUBMIT ASSESSMENTS ---------------------

  ///MANAGE ASSESSMENTS QUESTIONS--------------------------------
  createAssessmentQuestion(newquestion: any) {
    return this.http.post(this.rootURL + `assessment/addquestion`, newquestion);
  }
  getAssessmentQuestion(qid: number) {
    return this.http.get(this.rootURL + `assessment/geteditquestion?questionid=${qid}`);
  }
  deleteQuestion(questionid: any,batchid) {
    return this.http.delete(this.rootURL + `assessment/deletequestion?id=${questionid}&batchid=${batchid}`);
  }
  ///MANAGE ASSESSMENTS QUESTIONS--------------------------------


  ///MANAGE ASSESSMENTS--------------------------------

  createAssessment(newassessment: any) {
    return this.http.post(this.rootURL + `assessment/new`, newassessment);
  }

  updateAssessment(update: any) {
    return this.http.post(this.rootURL + `assessment/updateassessment`, update);
  }

  deleteAssessment(assessmentid: any) {
    return this.http.delete(this.rootURL + `assessment/deleteassessment?id=${assessmentid}`);
  }

  allowAssessmentRetake(details: any){
    return this.http.post(this.rootURL + `assessment/allowretake`, details);
  }

  deleteSubmittedAssessmentByStudent(assessmentid: number, submissionid: number, classid: number){
    return this.http.delete(this.rootURL + `assessment/deleteassessmentsubmissionforretake?assessmentid=${assessmentid}&submissionid=${submissionid}&classid=${classid}`);
  }
  ///MANAGE ASSESSMENTS--------------------------------

  //navigation
  goBackToAssessmentConsole(classID: number,batchID:number) {
    this.router.navigate(['/user/assessmentconsole'], { queryParams: { classid: classID ,batchid:batchID} });
  }

  goBackToAssessmentDetail(classID: number, assessmentID: number,batchID:number) {
    this.router.navigate(['/user/assessmentdetails'], { queryParams: { classid: classID,batchid: batchID, aid: assessmentID } });
  }

  getAssessmentBreadCrumb(assessmentID: number) {
    return this.http.get(this.rootURL + `assessment/assessmentcrumbs?aid=${assessmentID}`);
  }

  getLessonBreadCrumb(lessonID: number) {
    return this.http.get(this.rootURL + `assessment/lessoncrumbs?lid=${lessonID}`);
  }

  getReorderedQuestions(QuestionID: number, Direction: number) {
    return this.http.get(this.rootURL + `assessment/reorderquestion?qid=${QuestionID}&dir=${Direction}`);
  }

  uploadquestionfile(assessmentID: number, fileencoding: any, format: any, raw: any, negmarking: any, files: FileList) {
    let data = {
      assessmentid: assessmentID,
      fileencoding: fileencoding,
      format: format,
      raw: raw,
      negmarking: negmarking,
    }
    let datastring = JSON.stringify(data);
    let formData = new FormData();
    formData.append('file', files[0], files[0].name);
    formData.append('data', datastring);
    return this.http.post(this.rootURL + `assessment/assessmentquestionbatchupload`, formData);
  }

  getBatchCourseAssessments(moduleid: number,batchid:number) {
    return this.http.get<ModuleAssessmentBatchDate[]>(this.rootURL + `assessment/getmoduleassessmentbatchdate?moduleId=${moduleid}&batchId=${batchid}`);
  }

  updateBatchCourseAssessments(data:any) {
    return this.http.post<ModuleAssessmentBatchDate[]>(this.rootURL + `assessment/updatemoduleassessmentbatchdate`,data);
  }
}
